// removed by extract-text-webpack-plugin
module.exports = {"pof":"popup__pof__11Rc0","wrapper":"popup__wrapper__3GDlw popup__pof__11Rc0","cache":"popup__cache__1w326 popup__pof__11Rc0","popup":"popup__popup__1cSYe","btn":"popup__btn__2ZTCV","cancel":"popup__cancel__nJEqQ popup__btn__2ZTCV","confirm":"popup__confirm__10xPx popup__btn__2ZTCV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/popup/popup.scss
// module id = 222
// module chunks = 0